import classNames from 'clsx';
import React, { type FC, memo } from 'react';
import { getDuplicatePreviewUrl } from 'reactApp/modules/duplicates/duplicates.helpers';
import type { IDuplicatesPreviewItem } from 'reactApp/modules/duplicates/duplicates.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { Link } from 'reactApp/ui/Link/Link';

import styles from './DuplicatesPreviewVariant2.css';

interface IProps {
    rootClassName: string;
    imgClassName: string;
    items: IDuplicatesPreviewItem[];
    label: React.ReactNode;
    onClick: VoidFunction;
}

export const DuplicatesPreviewVariant2: FC<IProps> = memo(function DuplicatesPreviewVariant2(props: IProps) {
    const { rootClassName, imgClassName, items, label, onClick } = props;

    return (
        <Link id="duplicates" storage={EStorageType.duplicates} className={classNames(rootClassName, styles.root)} handleClick={onClick}>
            {label}
            {items.map((item, index) => (
                <img key={index} src={getDuplicatePreviewUrl(item)} className={classNames(imgClassName, styles.img)} />
            ))}
        </Link>
    );
});
